<template>
  <div class="versionManagement-box">
    <!-- 操作栏 -->
    <div class="action-bar">
      <el-select v-model="param.platform" clearable @change="handlerVersionList" size="small" placeholder="请选择设备">
        <el-option label="android" value="android"></el-option>
        <el-option label="ios" value="ios"></el-option>
        <el-option label="h5" value="h5"></el-option>
      </el-select>

      <el-button type="primary" size="small" @click="versionAction('add')">+新增版本</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" @sort-change="handleSortChange" ref="multipleTable">
      <el-table-column prop="platform" label="设备" align="center" width="140">
        <template slot-scope="scope">
          {{scope.row.platform || '未知'}}
        </template>
      </el-table-column>

      <!--
      <el-table-column label="APP类型" align="center" width="140">
        <template slot-scope="scope">
          {{scope.row.appType || '未知'}}
        </template>
      </el-table-column>
      <el-table-column prop="verCode" label="版本号" align="center" width="140">
        <template slot-scope="scope">
          {{scope.row.verCode || '未知'}}
        </template>
      </el-table-column>
      -->
      <el-table-column prop="verName" label="版本号" align="center" width="140">
        <template slot-scope="scope">
          <span>{{scope.row.verName || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="specVersion" label="指定升级版本号" align="center" width="140">
        <template slot-scope="scope">
          <span>{{scope.row.specVersion || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="buildId" label="包安装ID" align="center" width="200">
        <template slot-scope="scope">
          <span>{{scope.row.buildId || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="passCheck" label="提审通过" align="center" width="140">
        <template slot-scope="scope">
          {{scope.row.passCheck ? "是":"否"}}
        </template>
      </el-table-column>
      <el-table-column prop="isUpgrade" label="是否升级" align="center" width="140">
        <template slot-scope="scope">
          {{scope.row.isUpgrade ? "是":"否"}}
        </template>
      </el-table-column>
      <el-table-column prop="versionRange" label="更新范围" align="center" width="200">
        <template slot-scope="scope">
          <span>{{scope.row.versionRange.major || '未知 '}}</span>
          ~
          <span>{{scope.row.versionRange.minor || ' 未知'}}</span>
        </template>
      </el-table-column>
      <!--
      <el-table-column prop="size" label="版本大小" align="center" width="140">
        <template slot-scope="scope">
          <span>{{(scope.row.size || '0') + 'M'}}</span>
        </template>
      </el-table-column>
      -->
      <el-table-column prop="origin" label="来源" align="center" width="140" show="template">
        <template slot-scope="scope">
          {{scope.row.origin==0?"正常":(scope.row.origin==1?"TF版":"马甲包")}}
        </template>
      </el-table-column>
      <el-table-column prop="url" label="下载地址" align="center" width="300px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
         <span>{{scope.row.url}}</span>          
        </template>
      </el-table-column>
      <el-table-column prop="forcedUpdate" label="强制更新" align="center" width="120">
        <template slot-scope="scope">
          {{scope.row.forcedUpdate ? "是":"否"}}
        </template>
      </el-table-column>
      <el-table-column prop="isActive" label="是否开启" align="center" width="120">
        <template slot-scope="scope">
          {{scope.row.isActive ? "是":"否"}}
        </template>
      </el-table-column>
      <el-table-column prop="description" label="更新说明" align="center" width="250" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{scope.row.description || '未知'}}</span>
        </template>
      </el-table-column>
      <!--
      <el-table-column prop="id" label="包ID" align="center" width="220"></el-table-column>
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" disabled></el-switch>
        </template>
      </el-table-column>
      -->
      <el-table-column prop="createdAt" label="增加时间" align="center" width="200px">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="j" label="渠道标识" align="center" width="100px"></el-table-column> -->
      <el-table-column label="操作" align="center" width="200px" fixed="right">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="versionAction('edit',scope.row)"></el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="remove(scope.row.id)"></el-button>
        </template>
      </el-table-column>
      <template slot="origin" slot-scope="scope">{{ scope.row.origin|filterIsVip}}</template>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="param.pageNumber" :page-size="param.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!--新增、编辑version弹窗-->
    <version-action ref="versionAction" @handlerVersionList="handlerVersionList"></version-action>
  </div>
</template>
<script>
import VersionAction from './components/versionAction'
import API from '@/api'
import { sortEscape } from '@/utils/global'
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      tableData: [],
      total: 0,
      // 版本管理列表请求参数
      param: {
        pageNumber: 1,
        pageSize: 10,
        platform: '',
        origin:'',
        key: '',
        value: '',
      }
    }
  },
  created() {
    this.getVersionList(this.param)
  },
  components: {
    VersionAction
  },
  methods: {
    // 删除version
    remove(id) {
      this.$confirm('您确定要删除当前版本吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        API.getVersionDelets({ id: id }).then(res => {
          if (res.code === 200) {
            this.getVersionList();
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          } else {
            this.$message.error('删除失败！');
          }
        })
      })
    },
    // 监听编辑、或者添加成功过后重新拉去数据
    handlerVersionList() {
      this.param.pageNumber = 1
      this.param.pageSize = 10
      this.getVersionList()
    },
    // 新增、删除version
    versionAction(type, data) {
      this.$refs.versionAction.open(type, data);
    },
    // 请求版本管理模块配置列表
    getVersionList() {
      this.loading = true;
      API.getVersionList(this.param).then(res => {
        if (res.code === 200 && res.data.history) {
          this.tableData = res.data.history
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 数据排序
    handleSortChange(column) {
      this.param.value = sortEscape(column.order)
      this.param.key = column.prop;
      this.getVersionList()
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.param.pageSize = size
      this.param.pageNumber = 1
      this.getVersionList()
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.param.pageNumber = pageNumber
      this.getVersionList()
    }
  },
}
</script>
<style scoped>
</style>
